import { Dispatch, SetStateAction, useRef, useState } from "react"
import { Cota } from "./Cota";
import { DraggableWrapper } from "../../../../../../charts/components/wrappers/DraggableWrapper";
import axios from "axios";
import { RelatorioControlo } from "../../../../../../types";
import { useRelatorioControloForm } from "./useRelatoriosControlo";
import { IPecaParaEntrega } from "../../../../../Obras/newObra/IObra";
import CustomButtonSimple from "../../../../../../components/CustomMiscellaneous/CustomButtonSimple";
import { Field, Form, Formik } from "formik";
import { Select } from "@material-ui/core";
import { MenuItem, TextField } from "@mui/material";
import { Amostragem } from "./Amostragem";

export type ICota = {
    id?: number;
    internalId: number;
    initialX: number;
    initialY: number;
    x: number;
    y: number;
    number: number;
    intervaloDeTolerancia: {
        positiva: number;
        negativa: number;
    };
    valor: number;
    amostragens: { valor: number, numero: number }[];
    dispositivoMedicao: {
        id:number;
        gama: string;
        designacao: string;
        referencia: string;
    } | null
}

export function AplicadorDeCotas({ desenho, relatorioControlo, pecaEntrega, relatorioControloState, closeForm }:
    { desenho: any, relatorioControlo: RelatorioControlo, pecaEntrega: IPecaParaEntrega, relatorioControloState: { hasChanges: boolean, setHasChanges: any }, closeForm: ()=> void }) {

    const {
        svgRef,
        observacoes,
        setObservacoes,
        conforme,
        setConforme,
        cotas,
        updateCota,
        updateCotaMutation,
        deleteCota,
        doubleClickOnDesenho,
        updateAmostragens,
        addAmostragem,
        updateRelatorioMutation,
    } = useRelatorioControloForm(relatorioControlo, pecaEntrega, relatorioControloState, closeForm);

    const booleanOption = [
        { name: 'Sim', value: true },
        { name: 'Não', value: false }
    ];

    const initialValues: Partial<RelatorioControlo> = {
        conforme: relatorioControlo?.conforme || false,
        observacoes: relatorioControlo?.observacoes || "",
    }


    return (
        <div className="p-5">
            <div className="text-xl font-bold mb-2">Aplicador de cotas</div>
            <DraggableWrapper className="m-w-full overflow-x-auto relative">
                <div className="z-10" ref={svgRef} dangerouslySetInnerHTML={{ __html: desenho }}></div>
                <svg className="absolute top-0 left-0 w-full h-full z-20" onDoubleClick={(e) => doubleClickOnDesenho(e)}>
                    {cotas.map((c: ICota) => <Cota cota={cotas.filter((co: ICota) => co.internalId == c.internalId)[0]} updateCota={updateCota} updateCotaMutation={updateCotaMutation} deleteCota={deleteCota} svgRef={svgRef} />)}
                </svg>
            </DraggableWrapper>
            <div className="p-3">
                <div className="text-lg font-bold mb-2">Medições de Cotas</div>
                {
                    cotas.sort((a: ICota, b: ICota) => a.number - b.number).map((c: ICota) => <Amostragem cota={c} updateCota={updateCota} updateAmostragens={updateAmostragens} addAmostragem={addAmostragem}/>)
                }
            </div>


            <div className="flex flex-col p-5 w-2/3">
                <Form>

                    <div className="text-lg font-bold mt-2">Relatório</div>
                    <div className="p-2">
                        <div className="flex w-full justify-between items-center p-3">
                            <div className="w-1/3 ">Peça conforme</div>
                            <Field
                                className={"w-1/3 bg-white"}
                                name={`conforme`}
                                value={conforme || false}
                                as={Select}
                                margin={"dense"}
                                variant={'outlined'}
                                label={'Conforme'}
                                placeholder={'Conforme'}
                                renderValue={(item: any) => item ? 'Sim' : 'Não'}
                                onChange={(e: any) => setConforme(e.target.value)}
                            >
                                {booleanOption.map((c: any, idx: number) => <MenuItem key={idx} value={c.value}>{c.name}</MenuItem>)}
                            </Field>
                        </div>
                        <div className="flex flex-col w-full justify-between items-center p-3">
                            <div className="w-full text-white">Observações</div>
                            <Field
                                className={"w-full bg-white"}
                                name={`observacoes`}
                                value={observacoes || ""}
                                as={TextField}
                                margin={"dense"}
                                variant={'outlined'}
                                label={'Observaçoes'}
                                placeholder={'Observaçoes'}
                                onChange={(e: any) => setObservacoes(e.target.value)}
                            />
                        </div>
                    </div>
                </Form>
            </div>
            <CustomButtonSimple text="Submeter" onClick={() => updateRelatorioMutation.mutate({ relatorio: { conforme, observacoes } })} />


        </div>
    )

}